export const fileIcons = {
  zip: "mdi-folder-zip-outline",
  rar: "mdi-folder-zip-outline",
  htm: "mdi-language-html5",
  html: "mdi-language-html5",
  js: "mdi-nodejs",
  json: "mdi-code-json",
  md: "mdi-markdown",
  pdf: "mdi-file-pdf-box",
  png: "mdi-file-png-box",
  jpg: "mdi-file-jpg-box",
  jpeg: "mdi-file-jpg-box",
  gif: "mdi-file-gif-box",
  image: "mdi-file-image",
  bmp: "mdi-file-image",
  file: "mdi-file",
  mp4: "mdi-filmstrip",
  mp3: "mdi-filmstrip",
  mkv: "mdi-filmstrip",
  avi: "mdi-filmstrip",
  wmv: "mdi-filmstrip",
  mov: "mdi-filmstrip",
  txt: "mdi-file-document-outline",
  text: "mdi-file-document-outline",
  xls: "mdi-file-excel",
  xlsx: "mdi-file-excel",
  pptx: "mdi-file-powerpoint",
  ppt: "mdi-file-powerpoint",
  ppa: "mdi-file-powerpoint",
  doc: "mdi-file-document",
  dot: "mdi-file-document",
  docx: "mdi-file-document",
  other: "mdi-file-outline",
};

export function getSkillColor(skill) {
  switch (skill) {
    case "Management":
      return "blue";
    case "Finance and Accounting":
    case "Finance":
      return "purple lighten-2";
    case "Legal and Compliance":
    case "Legal":
      return "teal lighten-1";
    case "Global":
      return "warning darken-3";
    case "Governance":
      return "orange lighten-1";
    case "M & A and Finance":
      return "error lighten-1";
    case "IT Business":
      return "success";
    case "Human Resources and Organization":
      return "info darken-4";
  }
  return "secondary lighten-2";
}

export const colorPalettes = [
  "#F6B53F",
  "#6FAAB0",
  "#FF33F3",
  "#228B22",
  "#3399FF",
  "#FE4365",
  "#FC9D9A",
  "#F9CDAD",
  "#C8C8A9",
  "#83AF9B",
  "#D9CEB2",
  "#948C75",
  "#D5DED9",
  "#7A6A53",
  "#99B2B7",
  "#CBE86B",
  "#F2E9E1",
  "#1C140D",
  "#CBE86B",
  "#343838",
  "#005F6B",
  "#008C9E",
  "#00B4CC",
  "#00DFFC",
  "#00A8C6",
  "#40C0CB",
  "#F9F2E7",
  "#AEE239",
  "#8FBE00",
];
export const permissionModuleList = [
  "ViewDashboard",
  "ViewAgenda",
  "ViewDocuments",
  "ViewCalendar",
  "ViewPeople",
  "ViewCommunications",
  "ViewSurveyPolls",
  "CreateSurveyPolls",
  "UpdateSurveyPolls",
  "DeleteSurveyPolls",
  "ViewSurveyResponse",
  "ViewMeeting",
  "ViewMeetingTimer",
  "CreateAgenda",
  "UpdateAgenda",
  "DeleteAgenda",
  "CreateMeeting",
  "DeleteMeeting",
  "UpdateMeeting",
  "CreatePeople",
  "UpdatePeople",
  "DeletePeople",
  "CreateDirectory",
  "OpenDocument",
  "DownloadConvocation",
  "DownloadDocument",
  "UploadDocument",
  "DeleteDocument",
  "ViewAdmin",
  "ViewActivityLogs",
];

export const permissions = [
  {
    id: "ViewDashboard",
    name: "View Dashboard",
    description: "",
    screenName: "Dashboard",
  },
  {
    id: "ViewAgenda",
    name: "View Agenda",
    description: "",
    screenName: "Agenda",
  },
  {
    id: "CreateAgenda",
    name: "Create Agenda",
    description: "",
    screenName: "Agenda",
  },
  {
    id: "UpdateAgenda",
    name: "Update Agenda",
    description: "",
    screenName: "Agenda",
  },
  {
    id: "DeleteAgenda",
    name: "Delete Agenda",
    description: "",
    screenName: "Agenda",
  },
  {
    id: "ViewMeeting",
    name: "View Meeting",
    description: "",
    screenName: "Meeting",
  },
  {
    id: "CreateMeeting",
    name: "Create Meeting",
    description: "",
    screenName: "Meeting",
  },
  {
    id: "UpdateMeeting",
    name: "Update Meeting",
    description: "",
    screenName: "Meeting",
  },
  {
    id: "DeleteMeeting",
    name: "Delete Meeting",
    description: "",
    screenName: "Meeting",
  },
  {
    id: "ViewMeetingTimer",
    name: "View Meeting Timer",
    description: "",
    screenName: "Meeting",
  },
  {
    id: "ViewSurveyPolls",
    name: "View Survey Polls",
    description: "",
    screenName: "Survey Polls",
  },
  {
    id: "CreateSurveyPolls",
    name: "Create Survey Polls",
    description: "",
    screenName: "Survey Polls",
  },
  {
    id: "UpdateSurveyPolls",
    name: "Update Survey Polls",
    description: "",
    screenName: "Survey Polls",
  },
  {
    id: "DeleteSurveyPolls",
    name: "Delete Survey Polls",
    description: "",
    screenName: "Survey Polls",
  },
  {
    id: "ViewPeople",
    name: "View People",
    description: "",
    screenName: "People",
  },
  {
    id: "CreatePeople",
    name: "Create People",
    description: "",
    screenName: "People",
  },
  {
    id: "UpdatePeople",
    name: "Update People",
    description: "",
    screenName: "People",
  },
  {
    id: "DeletePeople",
    name: "Delete People",
    description: "",
    screenName: "People",
  },
  {
    id: "ViewDocuments",
    name: "View Documents",
    description: "",
    screenName: "Documents",
  },
  {
    id: "OpenDocument",
    name: "Open Documents",
    description: "",
    screenName: "Documents",
  },
  {
    id: "DownloadDocument",
    name: "Download Documents",
    description: "",
    screenName: "Documents",
  },
  {
    id: "UploadDocument",
    name: "Upload Documents",
    description: "",
    screenName: "Documents",
  },
  {
    id: "DeleteDocument",
    name: "Delete Documents",
    description: "",
    screenName: "Documents",
  },
  {
    id: "ViewCalendar",
    name: "View Calendar",
    description: "",
    screenName: "Calendar",
  },
  {
    id: "ViewCommunications",
    name: "View Communications",
    description: "",
    screenName: "Communications",
  },
  {
    id: "ViewSurveyResponse",
    name: "View Survey Response",
    description: "",
    screenName: "Survey Response",
  },
  {
    id: "CreateDirectory",
    name: "Create Directory",
    description: "",
    screenName: "Directory",
  },
  {
    id: "DownloadConvocation",
    name: "Download Convocation",
    description: "",
    screenName: "Convocation",
  },
  {
    id: "ViewAdmin",
    name: "View Admin",
    description: "",
    screenName: "Admin",
  },
  {
    id: "ViewActivityLogs",
    name: "View Activity Logs",
    description: "",
    screenName: "Activity Logs",
  },
];

export const skillsList = [
  {
    id: "1288f60e-c3a2-48d9-a596-d657f78bf12f",
    name: "Management",
    value: "Management",
  },
  {
    id: "164872431-4524-47a8-aa9b-521fd39ec2d2",
    name: "Finance and Accounting",
    value: "Finance and Accounting",
  },
  {
    id: "25950344-e1cf-4b9d-9199-38bd39ec60e7",
    name: "Governance",
    value: "Governance",
  },
  {
    id: "a20e5574-ddc2-4d4b-860f-4d48b4ff58ce",
    name: "Global",
    value: "Global",
  },
  {
    id: "b34f81f7-d5b7-4b84-a199-bba99e4c7d8a",
    name: "Legal and Compliance",
    value: "Legal and Compliance",
  },
  {
    id: "3d040934-00fc-49b6-8156-56a9ba18b062",
    name: "M & A and Finance",
    value: "M & A and Finance",
  },
  {
    id: "0e7800e5-251b-4426-bc43-977aa9501f59",
    name: "IT Business",
    value: "IT Business",
  },
  {
    id: "2d48cc18-79bf-4016-af8f-0000fd045de8",
    name: "Human Resources and Organization",
    value: "Human Resources and Organization",
  },
];

export const personalityTypesList = [
  {
    id: "c648ef16-1938-4820-aa68-affe357e87b7",
    name: "Architect",
    value: "Architect",
  },
  {
    id: "267178ae-f9a7-4b0f-8ec9-1ed1470f8821",
    name: "Logician",
    value: "Logician",
  },
  {
    id: "97e53412-c5c5-4c9c-8b60-9600a2304db3",
    name: "Commander",
    value: "Commander",
  },
  {
    id: "edc25c24-cf7a-4c5a-9dc6-f11e56c290fe",
    name: "Debater",
    value: "Debater",
  },
  {
    id: "c8fc78ae-2621-462c-9143-1d1a8c8084ae",
    name: "Advocate",
    value: "Advocate",
  },
  {
    id: "15812c6c-bc92-4cb4-b234-e5601570a3d9",
    name: "Protagonist",
    value: "Protagonist",
  },
  {
    id: "9d4e1821-0ffe-4f6e-96d4-54512791a54e",
    name: "Campaigner",
    value: "Campaigner",
  },
  {
    id: "bc0b6c96-380c-4a11-9c30-79fea94be008",
    name: "Virtuoso",
    value: "Virtuoso",
  },
  {
    id: "07b79a1e-67ef-448d-9b76-377748146004",
    name: "Entrepreneur",
    value: "Entrepreneur",
  },
];

export const companyNewsIds = [];
export const allowed_file = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/bmp",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-fontobject",
  "application/vnd.ms-fontobject",
  "application/vnd.oasis.opendocument.spreadsheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "text/plain",
  "application/zip",
  "application/x-zip",
  "application/x-zip-compressed",
  "application/vnd.rar",
  "application/x-rar-compressed",
  "multipart/x-zip",
  "application/gzip",
  "image/svg+xml",
  "application/vnd.ms-excel.sheet.macroEnabled.12"
];

export const video_audio_types = ["audio/mp3", "audio/mpeg", "audio/x-m4a"];

export const audio_video_file_types = [
  "audio/aac",
  "audio/x-m4a",
  "audio/m4a",
  "video/x-msvideo",
  "audio/mpeg",
  "video/mp4",
  "video/mpeg",
  "video/ogg",
  "audio/ogg",
  "audio/wav",
  "audio/x-wav",
  "audio/webm",
  "video/webm",
  "video/3gpp",
  "audio/3gpp", 
];

export const topic_file_types = [...allowed_file, ...audio_video_file_types];


export const generalRoles = [
  {
    id: "ViewLandingPage",
    name: "View Home Page",
    description: "To View Landing Page",
    screenName: "menu.home",
  },
  {
    id: "ViewAnnouncement",
    name: "View Announcement",
    description: "To view Announcement",
    screenName: "menu.home",
  },
  {
    id: "CreateAnnouncement",
    name: "Create Announcement",
    description: "To create Announcement",
    screenName: "menu.home",
  },
  {
    id: "UpdateAnnouncement",
    name: "Update Announcement",
    description: "To update Announcement",
    screenName: "menu.home",
  },
  {
    id: "DeleteAnnouncement",
    name: "Delete Announcement",
    description: "To delete Announcement",
    screenName: "menu.home",
  },
  {
    id: "ViewDashboard",
    name: "View Dashboard",
    description: "",
    screenName: "menu.dashboard",
  },
  {
    id: "CreateDashboard",
    name: "Create Dashboard",
    description: "",
    screenName: "menu.dashboard",
  },
  {
    id: "UpdateDashboard",
    name: "Update Dashboard",
    description: "",
    screenName: "menu.dashboard",
  },
  {
    id: "DeleteDashboard",
    name: "Delete Dashboard",
    description: "",
    screenName: "menu.dashboard",
  },
  // {
  //   id: "ViewAgenda",
  //   name: "View Agenda",
  //   description: "",
  //   screenName: "menu.agenda",
  // },
  // {
  //   id: "ViewAgendaAssignment",
  //   name: "View Agenda Assignment",
  //   description: "",
  //   screenName: "menu.agenda",
  // },
  // {
  //   id: "CreateAgenda",
  //   name: "Create Agenda",
  //   description: "",
  //   screenName: "menu.agenda",
  // },
  // {
  //   id: "UpdateAgenda",
  //   name: "Update Agenda",
  //   description: "",
  //   screenName: "menu.agenda",
  // },
  // {
  //   id: "DeleteAgenda",
  //   name: "Delete Agenda",
  //   description: "",
  //   screenName: "menu.agenda",
  // },
  // {
  //   id: "ViewMeeting",
  //   name: "View Meeting",
  //   description: "",
  //   screenName: "Meeting",
  // },
  // {
  //   id: "CreateMeeting",
  //   name: "Create Meeting",
  //   description: "",
  //   screenName: "Meeting",
  // },
  // {
  //   id: "UpdateMeeting",
  //   name: "Update Meeting",
  //   description: "",
  //   screenName: "Meeting",
  // },
  // {
  //   id: "DeleteMeeting",
  //   name: "Delete Meeting",
  //   description: "",
  //   screenName: "Meeting",
  // },
  // {
  //   id: "ViewMeetingTimer",
  //   name: "View Meeting Timer",
  //   description: "",
  //   screenName: "Meeting",
  // },
  // {
  //   id: "VotingRight",
  //   name: "Voting Right",
  //   description: "",
  //   screenName: "Meeting",
  // },
  {
    id: "ViewSurveyPolls",
    name: "View Survey Polls",
    description: "",
    screenName: "admin.surveyPolls",
  },
  {
    id: "CreateSurveyPolls",
    name: "Create Survey Polls",
    description: "",
    screenName: "admin.surveyPolls",
  },
  {
    id: "UpdateSurveyPolls",
    name: "Update Survey Polls",
    description: "",
    screenName: "admin.surveyPolls",
  },
  {
    id: "DeleteSurveyPolls",
    name: "Delete Survey Polls",
    description: "",
    screenName: "admin.surveyPolls",
  },
  {
    id: "ViewPeople",
    name: "View People",
    description: "",
    screenName: "menu.people",
  },
  {
    id: "CreatePeople",
    name: "Create People",
    description: "",
    screenName: "menu.people",
  },
  {
    id: "UpdatePeople",
    name: "Update People",
    description: "",
    screenName: "menu.people",
  },
  {
    id: "DeletePeople",
    name: "Delete People",
    description: "",
    screenName: "menu.people",
  },
  {
    id: "ViewDocuments",
    name: "View Documents",
    description: "",
    screenName: "menu.documents",
  },
  {
    id: "OpenDocument",
    name: "Open Documents",
    description: "",
    screenName: "menu.documents",
  },
  {
    id: "DownloadDocument",
    name: "Download Documents",
    description: "",
    screenName: "menu.documents",
  },
  {
    id: "UploadDocument",
    name: "Upload Documents",
    description: "",
    screenName: "menu.documents",
  },
  {
    id: "DeleteDocument",
    name: "Delete Documents",
    description: "",
    screenName: "menu.documents",
  },
  {
    id: "ViewCalendar",
    name: "View Calendar",
    description: "",
    screenName: "menu.calendar",
  },
  {
    id: "ViewCommunications",
    name: "View Communications",
    description: "",
    screenName: "admin.communications",
  },
  {
    id: "ViewSurveyResponse",
    name: "View Survey Response",
    description: "",
    screenName: "admin.surveyResponse",
  },
  {
    id: "ViewDirectory",
    name: "View Directory",
    description: "",
    screenName: "admin.directory",
  },
  {
    id: "CreateDirectory",
    name: "Create Directory",
    description: "",
    screenName: "admin.directory",
  },
  {
    id: "UpdateDirectory",
    name: "Update Directory",
    description: "",
    screenName: "admin.directory",
  },
  {
    id: "DeleteDirectory",
    name: "Delete Directory",
    description: "",
    screenName: "admin.directory",
  },
  {
    id: "DownloadConvocation",
    name: "Download Convocation",
    description: "",
    screenName: "admin.convocation",
  },
  {
    id: "ViewAdmin",
    name: "View Admin",
    description: "",
    screenName: "menu.admin",
  },
  {
    id: "ViewActivityLogs",
    name: "View Activity Logs",
    description: "",
    screenName: "admin.activitylogs",
  },
];

export const meetingBasedRoles = [
  {
    id: "ViewAgendaAssignment",
    name: "View Agenda Assignment",
    description: "",
    screenName: "menu.agenda",
  },
  {
    id: "CreateAgenda",
    name: "Create Agenda",
    description: "",
    screenName: "menu.agenda",
  },
  {
    id: "UpdateAgenda",
    name: "Update Agenda",
    description: "",
    screenName: "menu.agenda",
  },
  {
    id: "DeleteAgenda",
    name: "Delete Agenda",
    description: "",
    screenName: "menu.agenda",
  },
  {
    id: "ViewMeeting",
    name: "View Meeting",
    description: "",
    screenName: "Meeting",
  },
  {
    id: "CreateMeeting",
    name: "Create Meeting",
    description: "",
    screenName: "Meeting",
  },
  {
    id: "UpdateMeeting",
    name: "Update Meeting",
    description: "",
    screenName: "Meeting",
  },
  {
    id: "DeleteMeeting",
    name: "Delete Meeting",
    description: "",
    screenName: "Meeting",
  },
  {
    id: "ViewMeetingTimer",
    name: "View Meeting Timer",
    description: "",
    screenName: "Meeting",
  },
  {
    id: "VotingRight",
    name: "Voting Right",
    description: "",
    screenName: "Meeting",
  },
];

export const MAX_UPLOAD_SIZE = 1073741824;
export const MAX_PROFILE_PHOTO_SIZE = 2097152;  
export const LANDING_PAGE_WALLPAPER_SIZE = 3145728;
export const MAX_EMAIL_ATTACHMENT_SIZE = 10485760;
export const RESET_MFA_INITIAL_TIMEOUT = 120;
export const MESSAGE_SHEET_TIMEOUT = 3000;
export const TITLE_LENGTH_150 = 150;
export const TITLE_LENGTH_1000 = 1000;
export const DESCRIPTION_LENGTH_10000 = 10000;
export const MEETING_LINK_CHARACTER_LENGTH = 350;
export const DEFAULT_MEETING_TYPE_COLOR  = "#004c7a";

export const timeDigitTextLimit = 4;

export const colorCodes = ['#B6A6E9', '#876FD4', "#5E40BE", "#3D2785", "#21134D", "#004D99", "#0066CC", "#4394E5", "#63993D", "#3D7317"]

export default {
  video_audio_types,
  fileIcons,
  getSkillColor,
  colorPalettes,
  permissions,
  permissionModuleList,
  skillsList,
  timeDigitTextLimit,
  companyNewsIds,
  allowed_file,
  MAX_PROFILE_PHOTO_SIZE,
  generalRoles,
  meetingBasedRoles,
  colorCodes
};
